import './PCScreenPage.scss'
import {useState} from "react";
import {PROGRESS_BY_DEADLINE} from "../EndGamePage/EndGamePage";
import nea from "../../sounds/nea.mp3";
import keyboard from "../../sounds/keyboard.mp3";
import {t} from "i18next";



const PCScreenPage = (props) => {
  const {
    onChangeView,
    onUpdateTime,
    currentDay,
    currentDeadline,
    currentProgress,
    setCurrentProgress,
    currentHunger,
    setCurrentHunger,
    currentFatigue,
    setCurrentFatigue,
    soundsFX,
    soundsRef,
  } = props


  const workProgress =
    {
      3: [
        `${t('phrases.brainstorm')}`,
        `${t('phrases.initiate')}`,
        `${t('phrases.write_code')}`,
        `${t('phrases.more_coding')}`,
        `${t('phrases.add_graphics_music')}`,
        `${t('phrases.playable')}`,
        `${t('phrases.make_improvements')}`,
        `${t('phrases.awesome_game')}`
      ],
      5: [
        `${t('phrases.brainstorm')}`,
        `${t('phrases.initiate')}`,
        `${t('phrases.write_code')}`,
        `${t('phrases.more_coding')}`,
        `${t('phrases.add_graphics_music')}`,
        `${t('phrases.refactor_code')}`,
        `${t('phrases.fix_bugs')}`,
        `${t('phrases.extra_levels')}`,
        `${t('phrases.playable')}`,
        `${t('phrases.demo_version')}`,
        `${t('phrases.awesome_game')}`
      ],
      7: [
        `${t('phrases.brainstorm')}`,
        `${t('phrases.initiate')}`,
        `${t('phrases.write_code')}`,
        `${t('phrases.write_lot')}`,
        `${t('phrases.more_coding')}`,
        `${t('phrases.add_graphics')}`,
        `${t('phrases.make_music_in_studio')}`,
        `${t('phrases.refactor_code')}`,
        `${t('phrases.fix_bugs')}`,
        `${t('phrases.add_achievements')}`,
        `${t('phrases.additional_coding')}`,
        `${t('phrases.add_controllers')}`,
        `${t('phrases.playable')}`,
        `${t('phrases.demo_version')}`,
        `${t('phrases.awesome_game')}`
      ]
    }

  const [gameSubmitText, setGameSubmitText ] = useState('')
  const [showTired, setShowTired ] = useState(false)
  const [showHungry, setShowHungry ] = useState(false)

  const onProgressUpdate = () => {
    if(currentHunger + 70 > 100) {
      soundsFX.onPlay(nea, false,false, soundsRef)
      setShowHungry(true)
      return
    }
    if(currentFatigue + 60 > 100) {
      soundsFX.onPlay(nea, false,false, soundsRef)
      setShowTired(true)
      return
    }
    setCurrentProgress(prevState => prevState + 1)
    onUpdateTime(8)
    soundsFX.onPlay(keyboard, false,false, soundsRef)
    setCurrentHunger(prevState => prevState + 70 )
    setCurrentFatigue(prevState => prevState + 60 )
    if(gameSubmitText) {
      setGameSubmitText('')
    }
  }

  const onSubmitGame = () => {
    const text = PROGRESS_BY_DEADLINE[currentDeadline] - 3 <= currentProgress ? `${t('pcs-g-s')}` : `${t('pcs-g-n')}`
    setGameSubmitText(text)

  }

  const dayLeft = currentDeadline + 8 - currentDay

  return <div className="PCScreenPage">
    <div className="screen">
      <div className="left-side">
        <button className="big-button" onClick={onProgressUpdate}>
          {t('pcs-work')}
          <span className="b-small">{t('pcs-work-stats')}</span>
        </button>
        {dayLeft >= 0 ? <button className="big-button" onClick={()=>onSubmitGame()}>
            {t('pcs-submit')}
            <span className="b-small">{t('pcs-submit-stats')}</span>
        </button>
          : <button className="big-button" onClick={()=>onChangeView("NewGamePage")}> {t('pcs-ops')} </button>}
        { gameSubmitText === `${t('pcs-g-s')}` && <button className="big-button" onClick={()=>onChangeView("EndGamePage")}>
          {t('pcs-see')}
        </button>}
      </div>
      <div className="right-side">
        <div className="progress-notifier">
          <div className="block">EATch.io JAM: {dayLeft} {t('pcs-dl')}</div>

          <div className="block">
            <div>{t('pcs-progress')} </div>
            <div className="progress-line">
              <div className="progress" style={{width: currentProgress * 100 / PROGRESS_BY_DEADLINE[currentDeadline]+"%"}}>
              </div>
            </div>
          </div>

          <div className="block">
            <div>{t('pcs-status')}</div>
            <div>{workProgress[currentDeadline][currentProgress]}</div>
          </div>
        </div>
      </div>
    </div>
    {(showTired || showHungry || gameSubmitText) && <div className="notification">
      {showTired && <div> {t('pcs-tired')} </div>}
      {showHungry && <div> {t('pcs-hungry')} </div>}
      {gameSubmitText && <div>{gameSubmitText}</div>}
    </div>}
    <div className="bottom-bar">
      <button className="back-button" onClick={()=>{onChangeView("BedroomPage")}}>
        {t('pcs-gup')}
      </button></div>
  </div>
}

export default PCScreenPage